module.exports = __webpack_public_path__ + "static/media/Vazir-FD.8c64ceec.ttf";